import block from './block.json';

export const gdprThemeAttributes = {
	banner: {
		backgroundColor: '#000000',
		border: {
			color: '#000000',
			width: {
				top: [0, 0],
				right: [0, 0],
				bottom: [0, 0],
				left: [0, 0],
			},
			radius: {
				topLeft: [0, 0],
				topRight: [0, 0],
				bottomRight: [0, 0],
				bottomLeft: [0, 0],
			},
		},
		width: [288, 430],
		position: {
			right: [16, 32],
			bottom: [16, 32],
		},
		padding: {
			top: [10, 10],
			right: [10, 10],
			bottom: [10, 10],
			left: [10, 10],
		},
		title: {
			color: '#ffffff',
			typography: '@tokens.typographies.heading-4',
			textAlignment: 'left',
		},
		text: {
			color: '#ffffff',
			typography: '@tokens.typographies.paragraph',
			textAlignment: 'left',
		},
		link: {
			color: '#ffffff',
			typography: '@tokens.typographies.links',
			textAlignment: 'left',
		},
	},
	modal: {
		backgroundColor: '#ffffff',
		backdropColor: '#000000',
		border: {
			color: '#000000',
			width: {
				top: [0, 0],
				right: [0, 0],
				bottom: [0, 0],
				left: [0, 0],
			},
			radius: {
				topLeft: [0, 0],
				topRight: [0, 0],
				bottomRight: [0, 0],
				bottomLeft: [0, 0],
			},
		},
		title: {
			color: '#000000',
			typography: '@tokens.typographies.heading-4',
			textAlignment: 'left',
		},
		text: {
			color: '#000000',
			typography: '@tokens.typographies.paragraph',
			textAlignment: 'left',
		},
		closeButton: {
			color: '#000000',
		},
		tab: {
			backgroundColor: '#000000',
			border: {
				color: '#000000',
				width: {
					top: [0, 0],
					right: [0, 0],
					bottom: [0, 0],
					left: [0, 0],
				},
				radius: {
					topLeft: [0, 0],
					topRight: [0, 0],
					bottomRight: [0, 0],
					bottomLeft: [0, 0],
				},
			},
			title: {
				color: '#ffffff',
				typography: '@tokens.typographies.paragraph',
				textAlignment: 'left',
			},
			caption: {
				color: '#ffffff',
				typography: '@tokens.typographies.caption',
				textAlignment: 'left',
			},
			text: {
				color: '#000000',
				typography: '@tokens.typographies.paragraph',
				textAlignment: 'left',
			},
		},
		toggle: {
			enabled: '#378a00',
			disabled: '#6e6e6e',
		},
	},
	states: {
		hover: {}, // adds hover state
	},
};

export const GdprThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: gdprThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
